import React, { ReactNode } from 'react';
import Logo from '../../components/ui/Logo';

interface AuthLayoutProps {
  children: ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="flex justify-center">
          <Logo size="lg" />
        </div>
        <p className="mt-2 text-center text-sm text-gray-600">
          Repair Management System for Phone Repair Businesses
        </p>
        {children}
      </div>
    </div>
  );
};

export default AuthLayout;